import React from 'react'
import ReviewItem from '../ReviewItem/ReviewItem.js';
import RatingProgressBar from '../RatingProgressBar/RatingProgressBar.jsx';
import { RiStarSFill } from 'react-icons/ri';


const FeedBackSectionForOne = ({ title, rating, reviews, reviewCount }) => {

const fullStars = Math.floor(rating); // Calculate the full stars (e.g., 4 stars for a 4.5 rating)
const halfStars = rating % 1 >= 0.5 ? 1 : 0; // Check if there's a half star
const emptyStars = 5 - fullStars - halfStars; // Calculate the empty stars
return (
    <div className="flex flex-col gap-4 w-full">
        {/* Rating and Progress Bars */}
        <div className="flex-1">
            <h2 className="text-xl font-semibold">{title}</h2>
            <p className="text-3xl font-bold my-2">{rating ? rating.toFixed(2) : "0.00"}</p>
            <p className='text-base'> based on {reviewCount} ratings</p>
            <div className="flex flex-row text-4xl">
                {/* Display full, half, and empty stars dynamically */}
                {[...Array(fullStars)].map((_, index) => (
                    <RiStarSFill key={`full-${index}`} className="text-yellow-500" />
                ))}
                {halfStars > 0 && <RiStarSFill key="half" className="text-yellow-500 opacity-50" />} {/* You can adjust the opacity for half stars */}
                {[...Array(emptyStars)].map((_, index) => (
                    <RiStarSFill key={`empty-${index}`} className="text-gray-300" />
                ))}
            </div>
            <div className="flex flex-col w-[400px] gap-2 mt-4">
                {[5, 4, 3, 2, 1].map((star) => (
                    <RatingProgressBar
                        key={star}
                        star={star}
                        reviews={reviews}
                    />
                ))}
            </div>
        </div>

        {/* Reviews Section */}
        <div className="flex-1 overflow-y-auto h-96 md:h-full">
            <h2 className="text-xl font-semibold mb-2">Reviews ({reviewCount})</h2>
            <div className="border-2 p-2 rounded-lg grid grid-cols-1 md:grid-cols-2 max-h-96 overflow-y-auto">
                {reviews.map((review, index) => (
                    <ReviewItem key={index} review={review} />
                ))}
            </div>
        </div>
    </div>
);
};

export default FeedBackSectionForOne